import React from "react"
import {
  Link,
  useTranslation,
  Trans,
} from "@zestia/gatsby-plugin-react-i18next"
import ChevronDown from "../svg/icons/IconChevronDown"

import HubSpot from "@/icons/megamenu/HubSpot.svg"
import Salesforce from "@/icons/megamenu/Salesforce.svg"
import Pipedrive from "@/icons/megamenu/Pipedrive.svg"
import Copper from "@/icons/megamenu/Copper.svg"
import Keap from "@/icons/megamenu/Keap.svg"
import Nutshell from "@/icons/megamenu/Nutshell.svg"
import More from "@/icons/megamenu/More.svg"
import Stars from "@/icons/megamenu/Stars.svg"
import Android from "@/icons/megamenu/Android.svg"
import Apple from "@/icons/megamenu/Apple.svg"

const NavBarMenuFeatures = ({ showMenu, setShowMenu }) => {
  const { t } = useTranslation()

  return (
    <div className="menu">
      <Link
        to="/features/"
        className="nav-bar__btn"
        onClick={e => {
          e.preventDefault()
          setShowMenu()
        }}
      >
        <span>{t("navigation.features.nav-title")}</span>
        <ChevronDown
          className={`menu-icon ${showMenu ? "menu-icon__rotate" : ""}`}
        />
      </Link>
      <div
        className={`menu__mega-menu ${showMenu ? "menu__mega-menu--open" : ""}`}
      >
        {showMenu && (
          <>
            <div className="menu__mega-menu-container">
              <div className="menu__main grid-3-col">
                <Link
                  to="/features/contact-management-software/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-1.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-1.description")}
                  </p>
                </Link>

                <Link
                  to="/features/email-marketing/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-2.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-2.description")}
                  </p>
                </Link>

                <Link
                  to="/features/tasks-and-calendar/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-3.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-3.description")}
                  </p>
                </Link>

                <Link
                  to="/features/sales-pipeline/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-4.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-4.description")}
                  </p>
                </Link>

                <Link
                  to="/features/sales-analytics/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-5.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-5.description")}
                  </p>
                </Link>

                <Link
                  to="/features/project-management-crm/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-6.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-6.description")}
                  </p>
                </Link>

                <Link
                  to="/features/workflow-automation/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-7.title")}
                  </p>
                  <p className="menu__item-description mb-5 p--sm">
                    {t("navigation.features.feature-7.description")}
                  </p>
                </Link>

                <Link
                  to="/features/ai-content-assistant/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-8.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-8.description")}
                  </p>
                </Link>
                <Link
                  to="/features/communication-and-collaboration/"
                  className="menu__item-link"
                >
                  <p className="mb-0 menu__item-title">
                    {t("navigation.features.feature-9.title")}
                  </p>
                  <p className="menu__item-description mb-6 p--sm">
                    {t("navigation.features.feature-9.description")}
                  </p>
                </Link>
                <Link
                  to="/features/"
                  className="menu__item-link menu__item-link--mobile text-link text-link--dark"
                >
                  <p className="mb-0  menu__item-title">
                    {t("navigation.feature-links.feature-link-1")}
                  </p>
                </Link>
              </div>

              <Link
                to="/blog/how-to-import-your-data-from-another-crm/"
                className="menu__aside"
              >
                <p
                  className="heading-kicker menu__aside-title"
                  style={{ marginBottom: 0 }}
                >
                  <Stars className="menu__aside-title-icon" />
                  {t("navigation.features.side-section.title")}
                </p>
                <p className="p--sm">
                  <Trans
                    i18nKey={t("navigation.features.side-section.description")}
                    components={{
                      Span: <span className="text-link text-link--bare" />,
                    }}
                  />
                </p>

                <ul className="menu__aside-items">
                  <li className="menu__aside-item p--xs">
                    <HubSpot className="menu__aside-item-icon" />
                    HubSpot
                  </li>
                  <li className="menu__aside-item p--xs">
                    <Salesforce className="menu__aside-item-icon" />
                    Salesforce
                  </li>
                  <li className="menu__aside-item p--xs">
                    <Pipedrive className="menu__aside-item-icon" />
                    Pipedrive
                  </li>
                  <li className="menu__aside-item p--xs">
                    <Copper className="menu__aside-item-icon" />
                    Copper
                  </li>
                  <li className="menu__aside-item p--xs">
                    <Keap className="menu__aside-item-icon" />
                    Keap
                  </li>
                  <li className="menu__aside-item p--xs">
                    <Nutshell className="menu__aside-item-icon" />
                    Nutshell
                  </li>
                  <li className="menu__aside-item p--xs">
                    <More className="menu__aside-item-icon" />
                    {t("navigation.features.side-section.and-more")}
                  </li>
                </ul>
              </Link>
            </div>
            <div className="menu__footer">
              <div className="menu__footer-container">
                <div className="menu__footer-links">
                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/features/"
                  >
                    {t("navigation.feature-links.feature-link-1")}
                  </Link>

                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/features/security-and-permissions/"
                  >
                    {t("navigation.feature-links.feature-link-2")}
                  </Link>

                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/features/customize-capsule/"
                  >
                    {t("navigation.feature-links.feature-link-3")}
                  </Link>
                </div>
                <div className="menu__footer-mobile">
                  <Link
                    className="menu__footer-mobile-link p--xs"
                    to="/features/mobile-app/"
                  >
                    <Apple className="menu__footer-mobile-icon" />
                    {t("navigation.feature-mobile.ios")}
                  </Link>
                  <Link
                    className="menu__footer-mobile-link p--xs"
                    to="/features/mobile-app/"
                  >
                    <Android className="menu__footer-mobile-icon" />
                    {t("navigation.feature-mobile.android")}
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NavBarMenuFeatures
